import { makeAutoObservable, runInAction, when } from 'mobx';

import * as Cookie from '../../utils/Cookie';
import { queryClient } from '../../hooks/queries/queryClient';

import { Auth } from './Auth';

class AuthStore {
	rootStore;
	auth = null;
	isLoadingAuth = false;

	constructor(root) {
		makeAutoObservable(this);

		this.rootStore = root;
		when(() => !!this.auth);
	}

	get isSenior() {
		return this.hasRoleByName('senior');
	}

	get isSeoul() {
		return this.hasRoleByName('seoul');
	}

	get isYangcheon() {
		return this.hasRoleByName('yangcheon');
	}

	get isKid() {
		return this.hasRoleByName('kid');
	}

	get isAdmin() {
		return this.hasRoleByName('admin');
	}

	get isSamsung() {
		return this.hasRoleByName('samsung');
	}

	// async existsEmail(email) {
	// 	Cookie.set(
	// 		'token',
	// 		'eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjI1NDg4OTY5MzIsImlhdCI6MTY4NDg5NjkzMiwianRpIjoidG9yb29jQHRvcm9vYy5jb20ifQ.VtjgjnLHaWqQxea5AzaNV8O17_c67aL9JSJdN29ROvDACTfR4eUx9ezkZWphlNO_8hdV-qV_0KCiqiI2GbAcZw',
	// 		{ path: '/', maxAge: 86400 },
	// 	);
	// 	const result = await AuthApi.findMemberByEmail(email);
	// 	Cookie.remove('token');
	//
	// 	return result;
	// }

	hasRoleByName(roleName) {
		return this.auth?.roles?.some((role) => role.name === roleName) || false;
	}

	hasRoleById(roleId) {
		return this.auth?.roles?.some((role) => role.id === roleId) || false;
	}

	isLogin() {
		const isToken = Cookie.get('token');
		const isProfile = Cookie.get('profile');
		if (!isToken && !isProfile) Cookie.removeAll();

		return isToken && isProfile;
	}

	isEmail(email) {
		const emailRegex = new RegExp(
			/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/,
		);
		const result = emailRegex.test(email);

		return result;
	}

	isPassword(password) {
		// const EngRegex = new RegExp(/[a-zA-Z]/);
		// const NumRegex = new RegExp(/[0-9]/);
		// const SpecialRegex = new RegExp(/[$@$!%*?&]/);
		// const isEngPassword = EngRegex.test(password);
		// const isNumPassword = NumRegex.test(password);
		// const isSpecialPassword = SpecialRegex.test(password);
		//
		// const passwordLength = password.length;
		// const result =
		// 	passwordLength >= 8 &&
		// 	passwordLength <= 20 &&
		// 	((isNumPassword && isEngPassword) ||
		// 		(isEngPassword && isSpecialPassword) ||
		// 		(isSpecialPassword && isNumPassword));
		//
		// return result;

		const passwordLength = password.length;
		return passwordLength > 0;
	}

	isAuthInput(authData) {
		const { email, password } = authData;

		const isEmail = this.isEmail(email);
		const isPassword = this.isPassword(password);

		if (isEmail && isPassword) return true;

		return false;
	}

	logout() {
		this.auth = null;
		Cookie.removeAll();
		localStorage.removeItem('profiles');

		sessionStorage.clear();
		queryClient.clear();
	}

	async loadAuth(auth = {}) {
		if (this.isLoadingAuth) return; // 이미 로딩 중이면 return

		this.isLoadingAuth = true;
		try {
			console.log('loadAuth', auth);
			if (Object.keys(auth).length > 0) {
				const expiresAt = Date.now() + Cookie.DEFAULT_MAX_AGE * 1000; // 현재 시간 + 24시간
				console.log('expiresAt!!!!', expiresAt);
				Cookie.set('expiresAt', expiresAt.toString());
				Cookie.set('collectionId', auth.collectionId);
				Cookie.set('id', auth.id);
				Cookie.set('usage', auth.usage);
				Cookie.set('name', auth.name);
				Cookie.set('role', auth.roles);
				Cookie.set('token', auth.token);
				Cookie.set('collectionName', auth.collectionName);
				Cookie.set('type', auth.type);
				// Cookie.set('profiles', auth.profiles);
				localStorage.setItem('profiles', JSON.stringify(auth.profiles));
				if (auth.profile) {
					Cookie.set('profile', auth.profile);
				}
				if (auth.parentId) {
					Cookie.set('parentId', auth.parentId);
				}
			} else {
				auth.id = Cookie.get('id');
				auth.usage = Cookie.get('usage');
				auth.name = Cookie.get('name');
				auth.roles = Cookie.get('role');
				auth.token = Cookie.get('token');
				auth.collectionName = Cookie.get('collectionName');
				auth.collectionId = Cookie.get('collectionId');
				// auth.profiles = Cookie.get('profiles');
				auth.profiles = JSON.parse(localStorage.getItem('profiles'));
				auth.profile = Cookie.get('profile');
				auth.parentId = Cookie.get('parentId');
				Cookie.refresh();
			}

			runInAction(() => {
				this.auth = new Auth(this, auth);
			});
			await this.rootStore.likuStore.loadLiku();
		} finally {
			this.isLoadingAuth = false;
		}
	}

	updateAuth(data) {
		this.auth.setProfile(data.profile);
		this.loadAuth({ ...this.auth, profile: data.profile });
	}

	updateProfiles(profile) {
		const newProfiles = [...this.auth.profiles, profile];
		localStorage.setItem('profiles', JSON.stringify(newProfiles));
		this.auth.setProfiles(newProfiles);
	}

	// TAGS 건내 받으면 role로 필터링 해서 전달
	filterTags(tags) {
		let filteredTags = tags;
		filteredTags = tags?.filter((tag) => !tag?.name?.includes('번'));

		return filteredTags;
	}
}

export default AuthStore;
